export default defineNuxtRouteMiddleware(() => {
    const { loggedIn } = useUserSession()
    const localePath = useLocalePath()
    return navigateTo(localePath(loggedIn.value ? '/dashboard' : '/login'), { replace: true })
})
